import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'
import { calculateUnitTimers } from './helpers/unit_info'

export const UNIT_CREATE_INFO_REQUEST = 'unit_create_info/REQUEST'
export const UNIT_CREATE_INFO_SUCCESS = 'unit_create_info/SUCCESS'
export const UNIT_CREATE_INFO_ERROR = 'unit_create_info/ERROR'

export function startRequest() {
    return {
        type: UNIT_CREATE_INFO_REQUEST,
        payload: {},
    }
}

export function requestError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: UNIT_CREATE_INFO_ERROR,
        payload: errorData,
    }
}

export function requestSuccess(data) {
    return {
        type: UNIT_CREATE_INFO_SUCCESS,
        payload: calculateUnitTimers(data),
    }
}

export default function() {
    return async (dispatch, getState) => {
        const state = getState()
        if (state.unitCreateInfo.loading) {
            return
        }
        dispatch(startRequest())
        const url = '/game_api/units/create'
        httpRequest(url)
            .then(
                resp => dispatch(requestSuccess(resp)),
                errorData => dispatch(requestError(errorData))
            )
    }
}



// WEBPACK FOOTER //
// ./state/actions/unit_create_info.js